import React from "react";
import "./Calamus.scss";
import data from "./data1.json";
import Card from "../../Component/Card Viola/cardviola.jsx";
import Cliviaimages from "../../Media/CGB/Calamus/Clivia/Clivia.js";
import Magnoliaimages from "../../Media/CGB/Calamus/Magnolia/Magnolia.js";
import BreyniaAimages from "../../Media/CGB/Calamus/Breynia A/Breynia A.js";
import BreyniaBimages from "../../Media/CGB/Calamus/Breynia B/Breynia B.js";

const imageMap = {
  Cliviaimages,
  Magnoliaimages,
  BreyniaAimages,
  BreyniaBimages,
};

const produk = () => {
  return (
    <div id="calamus" className="produk">
      <h1>Cluster Calamus</h1>
      <h2>Cicilan Start From 5 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
